import * as React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import { Container } from './ConfirmModal';
import { Button } from '../ButtonV2/ButtonV2';
import { PageHeaderText } from '../Typography';
import { DrawerModal } from '../Mobile/Modal/DrawerModal';
import { useDeviceDetect } from '../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../colors-v2';

interface WarningModalProps {
  isModalOpen: boolean;
  onOk?: () => void;
  title: string;
  icon: any;
  children: any;
  okButton?: string;
  isShowFooter?: boolean;
  closable?: boolean;
}

const ModalComponent = ({
  className,
  closable,
  visible,
  onOk,
  children,
  isShowFooter,
  okButton,
  title,
}) => {
  const { isMobile } = useDeviceDetect();
  return isMobile ? (
    <DrawerModal
      className={className}
      onOk={onOk}
      visible={visible}
      okButtonText={okButton || 'start'}
      footer={isShowFooter}
    >
      {children}
    </DrawerModal>
  ) : (
    <Modal
      className={className}
      width={442}
      closable={closable}
      destroyOnClose
      footer={
        isShowFooter ? (
          <Button key="submit" onClick={onOk} fullWidth>
            {okButton}
          </Button>
        ) : null
      }
      open={visible}
    >
      {children}
    </Modal>
  );
};

const StyledPageHeaderText = styled(PageHeaderText)`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${colorsV2.black100};
`;

const WarningModal = (props: WarningModalProps) => {
  const {
    onOk,
    title,
    isModalOpen,
    children,
    icon,
    okButton,
    isShowFooter = true,
    closable = true,
  } = props;

  return (
    <ModalComponent
      title={title}
      className="dol-modal"
      closable={closable}
      isShowFooter={isShowFooter}
      visible={isModalOpen}
      onOk={onOk}
      okButton={okButton}
    >
      <Container>
        {icon}
        <StyledPageHeaderText>{title}</StyledPageHeaderText>
        <div>{children}</div>
      </Container>
    </ModalComponent>
  );
};

export default React.memo(WarningModal);
